// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #0d9488;
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000; /* Ensure it's above other content */
  opacity: 1;
  transition: opacity 0.5s ease-in-out, bottom 0.5s ease-in-out; /* Or top for top positioning */
}

.toast-message {
  font-size: 1rem;
  text-align: center;
}

/* Optional: Add a class to hide the toast for transitions */
.toast-container.hide {
  opacity: 0;
  bottom: -100px; /* Or top: -100px; if positioned at the top */
}
`, "",{"version":3,"sources":["webpack://./src/components/toast/Toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa,EAAE,oCAAoC;EACnD,UAAU;EACV,6DAA6D,EAAE,+BAA+B;AAChG;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,cAAc,EAAE,6CAA6C;AAC/D","sourcesContent":[".toast-container {\r\n  position: fixed;\r\n  top: 20px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: #0d9488;\r\n  color: white;\r\n  padding: 15px 25px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000; /* Ensure it's above other content */\r\n  opacity: 1;\r\n  transition: opacity 0.5s ease-in-out, bottom 0.5s ease-in-out; /* Or top for top positioning */\r\n}\r\n\r\n.toast-message {\r\n  font-size: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n/* Optional: Add a class to hide the toast for transitions */\r\n.toast-container.hide {\r\n  opacity: 0;\r\n  bottom: -100px; /* Or top: -100px; if positioned at the top */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
